import { Button } from "../form/Button";
import "./ReportStatusCard.css";

type ReportStatusCardProps = {
    title: string;
    subtitle?: string;
    description?: string;
    actionLabel?: string;
    onAction?: () => void;
};

export const ReportStatusCard: React.FC<ReportStatusCardProps> = ({
    title,
    subtitle,
    description,
    actionLabel,
    onAction
}) => {
    return (
        <div className="report-status-card">
            <h3>{title}</h3>
            {subtitle && <p className="report-status-card-subtitle">{subtitle}</p>}
            {description && <p className="report-status-card-description">{description}</p>}
            {actionLabel && onAction && (
                <Button name={actionLabel} action={onAction} textSize={12} />
            )}
        </div>
    );
};
